var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-header',{staticClass:"pb-6"},[_c('div',{staticClass:"row align-items-center py-4"})]),_c('div',{staticClass:"container-fluid mt--6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8"},[_c('users-table')],1),_c('div',{staticClass:"col-xl-4"},[_c('user-form')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }